import React from "react";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import { useParams } from "react-router-dom";

import AdminOnly from "../../../../components/AdminOnly";
import CustomeButton from "../../../../components/Button/index";
import PersonalInformationForm from "./PersonalInformationForm";
import useEditPersonalInformation from "../../actions/useEditPersonalInformation";
import ToastMessage from "~/components/ToastMessage";
import AuditSidebar from "~/components/audit-sidebar/AuditSidebar";
import API_ROUTES from "~/api-routes-v2";

const EditPersonalInformation = () => {
  const { id } = useParams();
  const {
    genstate,
    handleEnableEdit,
    handleUpdatePersonalInformation,
    handleDiscardEdit,
    handleChange,
    setAuditSidebarVisible,
    reset,
    toastRef,
  } = useEditPersonalInformation();
  const auditLabels = () => ({
    update: "Information Updated",
    create: `Employee Registry Created`,
    delete: `Employee Registry Deleted`,
  });
  return (
    <>
      <Card className="card-onboard">
        <div className="formgrid grid flex justify-content-between mb-4 align-items-center">
          <div className="">
            <p className="heading m-0 mb-2">Personal Information</p>
            <p className="description m-0">
              Personal information and contact details for this employee.
            </p>
          </div>
          <AdminOnly>
            <div className="flex gap-1">
              {genstate.isEdit ? (
                <>
                  <CustomeButton
                    label="Discard"
                    variant="outlined"
                    className="mr-2"
                    onClick={handleDiscardEdit}
                  />
                  <CustomeButton
                    label={"Save Changes"}
                    variant="contained"
                    onClick={handleUpdatePersonalInformation}
                    loading={genstate?.isUpdating}
                    disabled={genstate?.isUpdating || genstate?.isSaveBtn}
                    className={`mr-2 access-btn  ${genstate?.isSaveBtn && "disable"}`}
                    iconPos="right"
                  />
                </>
              ) : (
                <>
                  <Button
                    className="edit-button"
                    onClick={() => setAuditSidebarVisible(true)}
                  >
                    View History
                    <span className="pi pi-history mb-1 ml-2" />
                  </Button>
                  <CustomeButton
                    label="Edit"
                    variant="contained"
                    className="mr-2 access-btn"
                    onClick={handleEnableEdit}
                    icon="pi pi-pencil"
                    iconPos="right"
                  />
                </>
              )}
            </div>
          </AdminOnly>
        </div>
        <div className="formgrid grid">
          <PersonalInformationForm
            personalInformation={genstate.geninfo}
            isLoading={!genstate.isDataAvailable}
            handleChange={handleChange}
            isEdit={genstate.isEdit}
            resetForm={reset}
          />
        </div>

        {genstate.isAuditSidebarVisible && (
          <AuditSidebar
            heading="Personal Information"
            endpoint={API_ROUTES.FETCH_EMPLOYEE_AUDIT}
            id={id}
            objectType="PERSONAL_INFORMATION"
            labels={auditLabels}
            setSidebarToggle={setAuditSidebarVisible}
            sidebarToggle={genstate.isAuditSidebarVisible}
          />
        )}
        <ToastMessage ref={toastRef} />
      </Card>
    </>
  );
};

export default EditPersonalInformation;
